import React from "react";
import Skeleton from "react-loading-skeleton";

const BlogCardLoading = () => {
  return (
    <div className="bg-[#222] xl:w-full text-gray-200 h-auto flex flex-col gap-5 rounded-2xl shadow-[0px_5px_25px_rgba(79,105,139,.09)] group hover:shadow-xl transition-all duration-300">
      {/* post image */}
      <div className="post-img w-full min-h-[208px] relative overflow-hidden rounded-t-2xl">
        <Skeleton className="w-full h-full rounded-t-2xl" />
      </div>

      <div className="w-full flex flex-col gap-5 p-5 pt-0">
        {/* post title */}
        <div className="">
          <Skeleton className="w-full h-7 block rounded-lg -mb-5" />
        </div>

        {/* post desc */}
        <div className="post-desc text-xs text-gray-400 -mb-5">
          <Skeleton count={3} className="w-full h-4 block rounded-md" />
        </div>

        {/* post details */}
        <div className="flex items-center gap-5">
          <div className="">
            <Skeleton className="w-16 h-5 block rounded-md -mb-5" />
          </div>

          <div className="">
            <Skeleton className="w-16 h-5 block rounded-md -mb-5" />
          </div>
        </div>

        {/* post button */}
        <div className="post-readmore w-full flex justify-center items-center pt-4 gap-3 border-t border-gray-800 ">
          <div className="">
            <Skeleton className="w-24 h-7 block rounded-lg -mb-6" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCardLoading;
